import React from "react";

const TermsOfUseData = [
    {
        id: 15,
        title: `TERMS OF USE`,
        content: '',
        location: `/terms-of-use`,
        data: null,
    },
    {
        id: 15,
        title: `WEBSITE TERMS OF USE`,
        content: (
            <>
                Drivosity, LLC is pleased to make the website located at Drivosity.com (the “Site”) available for
                your use and benefit. By using the Site you agree to be bound by the Terms of Use set forth
                below. Use of this Site is strictly voluntary. If you do not agree to these Terms of Use and the
                Privacy Policy, you must immediately log off the Site and may not use the Site.
                These Terms of Use apply to your access to and use of this Site and do not alter in any way the
                terms and conditions of any other agreement you may have with Drivosity, unless otherwise
                directed by Drivosity. If you breach any of these terms and conditions, your authorization to use
                this Site automatically terminates and you must immediately discontinue use of the Site.
                To access and use certain features of the Site, you may be required to register with Drivosity
                and use a login/registration page and you must agree to be bound by any additional applicable
                terms and conditions contained there.
            </>
        ),
        location: `/terms-of-use`,
        data: null,
    },
    {
        id: 15,
        title: `COLLECTION OF VISITOR INFORMATION ON THIS SITE`,
        content: (
            <>
                Any information collected at this Site is governed by our Privacy Policy, unless otherwise stated.
            </>
        ),
        location: `/terms-of-use`,
        data: null,
    },
    {
        id: 15,
        title: `COPYRIGHT`,
        content: (
            <>
                All content, software, and technology included on this Site or used in the operation of this Site is
                the owned or licensed property of Drivosity or its content, software, and technology suppliers,
                and is protected by U.S. and international copyright laws. In addition, the compilation (meaning
                the collection, arrangement, and assembly) of all content on this Site is the exclusive property of
                Drivosity and protected by U.S. and international copyright laws. Drivosity grants you permission
                to view and use content, software, and technology made available to you on the Site in
                connection with your own personal, noncommercial use of the Site. Any other use, including the
                reproduction, modification, distribution, transmission, republication, display, or performance, of
                the content, software, and technology on this Site is strictly prohibited without written permission
                from Drivosity.
            </>
        ),
        location: `/terms-of-use`,
        data: null,
    },
    {
        id: 15,
        title: `TRADEMARKS`,
        content: (
            <>
                The trademarks, service marks, trade dress, and “look and feel” (the “Trademarks”) used and
                displayed on this Site are registered and unregistered Trademarks of Drivosity and others.
                Nothing on this Site shall be construed as granting any license or right to use any Trademark
                displayed on this Site without the prior written permission of the Trademark owner. Other
                product and company names mentioned in this Site may be the Trademarks of their respective
                owners.
            </>
        ),
        location: `/terms-of-use`,
        data: null,
    },
    {
        id: 15,
        title: `OTHER INTELLECTUAL PROPERTY`,
        content: (
            <>
                All other intellectual property rights related to the content, software, and technology included on
                this Site or used in the operation of this Site, including without limitation, patents, trade secrets,
                trade dress, publicity rights, character rights, titles, and artistic and moral rights are the owned
                or licensed property of Drivosity. Any use of these rights without the prior written permission of
                Drivosity is strictly prohibited.
            </>
        ),
        location: `/terms-of-use`,
        data: null,
    },
    {
        id: 15,
        title: `ACCURACY`,
        content: (
            <>
                Information on this Site may contain typographical errors, inaccuracies, or omissions. Drivosity
                reserves the right to correct any errors, inaccuracies, or omissions and to change or update
                information at any time without notice to you.
            </>
        ),
        location: `/terms-of-use`,
        data: null,
    },
    {
        id: 15,
        title: `DISCLAIMER OF WARRANTIES`,
        content: (
            <>
                THIS SITE AND ALL CONTENT, PRODUCTS AND SERVICES AVAILABLE THROUGH THE
                SITE ARE PROVIDED ON AN “AS IS, WITH ALL DEFECTS” AND “AS AVAILABLE” BASIS
                WITHOUT WARRANTIES OF ANY KIND, EXPRESS, IMPLIED, STATUTORY OR
                OTHERWISE. DRIVOSITY DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED,
                INCLUDING WITHOUT LIMITATION, WARRANTIES OF TITLE, NON- INFRINGEMENT, AND
                IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
                SATISFACTORY QUALITY, ACCURACY OF INFORMATIONAL CONTENT, AND ANY
                WARRANTIES ARISING OUT OF ANY COURSE OF DEALING OR USAGE OF TRADE.
                DRIVOSITY MAKES NO REPRESENTATION THAT THE SITE OR ANY CONTENT IS FREE
                FROM ERRORS, VIRUSES, BUGS, OR OTHER HARMFUL COMPONENTS. DRIVOSITY
                MAKES NO REPRESENTATION OR WARRANTY THAT CONTENT PROVIDED ON THIS
                SITE IS APPLICABLE OR APPROPRIATE FOR USE IN LOCATIONS OUTSIDE OF THE
                UNITED STATES. NOTHING IN THESE TERMS OF USE OR IN ANY ORAL OR WRITTEN
                DESCRIPTION OF THIS SITE WILL CONSTITUTE A REPRESENTATION OR WARRANTY
                WITH RESPECT TO THIS SITE.
                YOU ACKNOWLEDGE, BY YOUR USE OF THIS SITE, THAT SUCH USE IS AT YOUR SOLE
                RISK.
            </>
        ),
        location: `/terms-of-use`,
        data: null,
    },
    {
        id: 15,
        title: `LIMITATION OF LIABILITY`,
        content: (
            <>
                IN NO EVENT SHALL DRIVOSITY, ITS AFFILIATES, OR AGENTS BE LIABLE FOR ANY
                DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES
                ARISING OUT OF OR IN ANY WAY CONNECTED WITH YOUR USE OF THIS SITE,
                WHETHER BASED ON CONTRACT, TORT, WARRANTY, STRICT LIABILITY OR
                OTHERWISE, EVEN IF ADVISED OF THE POSSIBILITY OF ANY SUCH DAMAGES.
                CERTAIN STATE LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR
                THE EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO
                YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS, EXCLUSIONS, OR LIMITATIONS MAY
                NOT APPLY TO YOU, AND YOU MAY HAVE ADDITIONAL RIGHTS.
                Under no circumstances whatsoever shall Drivosity’s aggregate liability resulting from or relating
                to your use of this Site exceed Five United States Dollars (USD $5.00).
            </>
        ),
        location: `/terms-of-use`,
        data: null,
    },
    {
        id: 15,
        title: `PROHIBITED ACTIVITIES AND VISITOR OBLIGATIONS`,
        content: (
            <>
                As a visitor or user of this Site you shall not:
            </>
        ),
        location: `/terms-of-use`,
        data: null,
    },
    {
        id: 15,
        title: `PROHIBITED ACTIVITIES AND VISITOR OBLIGATIONS`,
        content: (
            <>
                <li>violate any applicable law or regulation;</li>
                <li>upload, post, use, transmit, or otherwise make available, including by email, (each, a “Post”) any content or information that is false or inaccurate;</li>
                <li>Post any content that is unlawful, harmful, threatening, abusive, harassing, tortious, defamatory, vulgar, obscene, libelous, invasive of another&#39;s privacy, or content that could otherwise be considered to be objectionable;</li>
                <li>impersonate or use the identity of another person or organization, or falsely state or otherwise misrepresent your affiliation with a person or organization;</li>
                <li>Engage in any activities or manipulate identifying material to misrepresent the origin of content;</li>
                <li>Post any content that is subject to any disclosure restrictions;</li>
                <li>Post any materials, items, information or content that infringes or otherwise violates any patent, copyright, trademark, or any other intellectual property rights;</li>
                <li>Post any unsolicited or unauthorized advertising or promotional materials, including without limitation, junk mail, spam, chain letters, pyramid schemes, or any other form of solicitation;</li>
                <li>use the Site for any activity that is unlawful, harmful, threatening, abusive, harassing, stalking, tortious, defamatory, vulgar, obscene, libelous, invasive of another&#39;s privacy, or that could otherwise be considered to be objectionable;</li>
                <li>Post any material that contains software viruses or any other corrupt computer code, files or programs that impair the use of any computer software or hardware or telecommunications equipment;</li>
                <li>interfere with or otherwise limit the use of this Site by other users; or collect, compile, or store personal information about other users of this Site;</li>
                <li>disrupt or interfere with the security of, operation of, or otherwise cause harm to, this Site or the systems resources; accounts; usernames and passwords; servers; or networks connected to or accessible through this Site or any affiliated or linked sites</li>
                <li>use any robot, spider, other automatic device, or manual process to “screen scrape,” monitor, “mine,” or copy the web pages on the Site or the content contained therein without Drivosity’s prior, express, and written permission;</li>
                <li>use this Site for your own commercial purposes.</li>
            </>
        ),
        location: `/terms-of-use`,
        data: null,
    },
    {
        id: 15,
        title: `PROHIBITED ACTIVITIES AND VISITOR OBLIGATIONS`,
        content: (
            <>
                You agree that you are solely responsible for the Posting of any content (e.g., text, images,
                photographs, videos) that you make available on or send through the Site (“User Content”). In
                addition to the rights granted to Drivosity elsewhere in these Terms of Use, you hereby grant
                Drivosity the irrevocable right to copy, display, and use User Content in connection with the Site
                and for the purposes related to your Post of the User Content. Drivosity does not endorse any
                User Content submitted to the Site, or endorse any opinion, recommendation, or advice
                expressed therein. Drivosity expressly disclaims any and all liability in connection with User
                Content. Although Drivosity has no obligation to screen, edit, or monitor any of the User
                Content, accounts, or user conduct on the Site, Drivosity reserves the right, and has absolute
                discretion, to remove, screen, or edit any User Content, accounts, and to monitor any user
                conduct on the Site at any time and for any reason without notice. Your User Content may be
                available on the Site for a limited period of time, as determined by Drivosity in its sole discretion.
                You are solely responsible for creating backup copies and replacing any of your User Content at
                your sole cost and expense.
                By the Posting of User Content to the Site, you represent and warrant that: (a) the User Content
                is non-confidential is not subject to disclosure restrictions under any applicable data privacy
                laws, rules, or regulations; (b) you have all necessary rights to Post the User Content to the Site
                and to grant the rights to Drivosity you grant in these Terms of Use; (c) the User Content is
                accurate and not misleading or harmful in any manner; and (d) the User Content, and the use
                and the Post thereof in connection with the Site, does not and will not violate these Terms of
                Use or any law, rule, or regulation. All User Content becomes the property of Drivosity and
                Drivosity may use the User Content for any purpose. See the Submission section below for
                more information.
            </>
        ),
        location: `/terms-of-use`,
        data: null,
    },
    {
        id: 15,
        title: `THIRD PARTY PROVIDERS OF FUNCTIONALITY`,
        content: (
            <>
                Drivosity may have functionality on the Site that is provided, in whole or in part, by a third party
                service provider. You can usually identify such third party functionality by the use of a trademark
                not owned by Drivosity on or near the functionality. For such third party functionality, you will
                need to review the terms of use and privacy policy for that third party, which in some cases may
                require you to visit that party’s website and locate the terms of use and privacy policy. Your
                review should include determining whether such terms and policy are acceptable to you. If they
                are not, do not use the associated functionality on our Site.
            </>
        ),
        location: `/terms-of-use`,
        data: null,
    },
    {
        id: 15,
        title: `INTERACTIONS WITH OTHERS`,
        content: (
            <>
                Your correspondence, interactions, or business dealings with third parties facilitated on or
                through the Site, including payment and delivery of goods or services, and any other terms,
                conditions, warranties, or representations associated with such dealings, are solely between
                you and such parties. You understand and acknowledge that these third parties are not agents,
                employees or independent contractors under the control of Drivosity. Drivosity makes no
                representations or warranties and shall not be liable for any action or omission of these third
                parties.
                Drivosity shall not be responsible or liable for any claims, loss, or damage of any sort incurred
                as the result of any such dealings or as the result of use of the Site. It is your responsibility to
                make whatever investigation you feel necessary or appropriate before proceeding with any
                activities or dealings with any of these third parties. Drivosity disclaims any liability with respect
                to such activities or dealings. If there is a dispute between you and any such third party, you
                understand and agree that Drivosity is under no obligation to become involved.
            </>
        ),
        location: `/terms-of-use`,
        data: null,
    },
    {
        id: 15,
        title: `INDEMNIFICATION`,
        content: (
            <>
                You agree to indemnify, defend, and hold Drivosity and its successors and assigns harmless
                from and against and in respect of any and all third party claims, demands, losses, costs,
                expenses, obligations, liabilities, damages, recoveries, and deficiencies, including interest,
                penalties, and reasonable attorneys fees that Drivosity incurs or suffers which relate to your use
                of this Site, your failure to perform any of your obligations under these Terms of Use, or your
                breach of any of your representations or warranties made under these Terms of Use.
            </>
        ),
        location: `/terms-of-use`,
        data: null,
    },
    {
        id: 15,
        title: `LINKS TO OTHER WEB SITES`,
        content: (
            <>
                The Site may contain links to other websites. Additionally, other websites may contain links to
                this Site. Drivosity does not review or monitor the websites linked to this Site and Drivosity is not
                responsible for the content or policies of any other websites. Any link established by Drivosity
                does not constitute an endorsement of the other websites or create a relationship between
                Drivosity and the operators of other websites. Drivosity disclaims any liability with respect to
                your use of any other website, and you release Drivosity from any liability related to your use of
                any link to another website or your use of any other website. Where this Site contains a link to
                another website owned and/or operated by Drivosity, such website use may be subject to
                different and additional terms of use and privacy policy terms and conditions.
            </>
        ),
        location: `/terms-of-use`,
        data: null,
    },
    {
        id: 15,
        title: `CHANGES TO TERMS OF USE`,
        content: (
            <>
                Drivosity may revise these Terms of Use at any time without notice. Any use of this Site
                following the date on which changes to these Terms of Use or the Privacy Policy are published
                on this Site shall constitute your acceptance of all such changes. You expressly agree that
                Drivosity shall have no obligation to provide you with any notice of any changes, and you hereby
                expressly waive any right you may have to receive notice of any changes to these Terms of Use
                or the Privacy Policy.
            </>
        ),
        location: `/terms-of-use`,
        data: null,
    },
    {
        id: 15,
        title: `CONTINUED OPERATION, ACCESSIBILITY, AND MAINTENANCE OF THIS SITE`,
        content: (
            <>
                Drivosity may modify, change, suspend, terminate or discontinue the operation of part or all of
                this Site without notice to you and Drivosity reserves the right to refuse service to anyone at any
                time, with or without cause.
            </>
        ),
        location: `/terms-of-use`,
        data: null,
    },
    {
        id: 15,
        title: `YOUR ACCOUNT`,
        content: (
            <>
                If you are a registered user of this Site, you are responsible for maintaining the confidentiality of
                your account and password and for restricting access to your computer. You agree to accept
                responsibility for all activities that occur under your account or password. By using the Site, you
                agree to: (a) provide true, accurate, current, and complete information about you; (b) maintain
                and promptly update such information to keep it true, accurate, current, and complete; and
                (c) notify us of any security breach or unauthorized use of your account or password. Drivosity
                has the right, without notice and in its sole discretion, to suspend or terminate your access to
                the Site and to refuse or restrict access or service, terminate accounts, and to remove or edit
                content on the Site.
            </>
        ),
        location: `/terms-of-use`,
        data: null,
    },
    {
        id: 15,
        title: `GENERAL PROVISIONS`,
        content: (
            <>
                English has been used in the preparation of these Terms of Use, and English shall be the
                controlling language with respect to these Terms of Use and their interpretation.
                Any failure by Drivosity to enforce any provision of these Terms of Use shall not be construed
                as a waiver of any provision or the right to enforce same.
                These Terms of Use shall be governed by the laws of the State of Florida, USA, without giving
                effect to any principles or conflicts of laws. For the purpose of resolving conflicts relating to or
                arising out of these Terms of Use, or arising out of any other dispute or claim associated with
                Drivosity, you irrevocably and unconditionally: (i) consent to submit to the exclusive jurisdiction
                of the state and federal courts located in the State of Florida, USA, (the “Florida Courts”) for any
                litigation or dispute arising out of or relating to these Terms of Use; (ii) agree not to commence
                any litigation arising out of or relating to these Terms of Use except in the Florida Courts; (iii)
                agree not to plead or claim that such litigation brought therein has been brought in an
                inconvenient forum; and (iv) agree the Florida courts represent the exclusive jurisdiction for all
                disputes relating to these Terms of Use.
                If any portion of these Terms of Use is held to be invalid, such holding shall not invalidate the
                other provisions of these Terms of Use.
                Use of this Site is unauthorized in any jurisdiction that does not give full effect to all provisions of
                these Terms of Use, including without limitation this paragraph and the warranty disclaimers and
                liability exclusions above. Use of this Site is unauthorized in any jurisdiction where all or any
                portion of this Site may violate any legal requirements and you agree not to access this Site in
                any such jurisdiction.
                You are responsible for compliance with applicable laws.
            </>
        ),
        location: `/terms-of-use`,
        data: null,
    },
    {
        id: 15,
        title: `SUBMISSIONS`,
        content: (
            <>
                Any and all questions, comments, suggestions, and similar materials or information that you
                send or submit to Drivosity through this Site (collectively, “Submissions”), shall become
                Drivosity’s property; and you hereby transfer, sell, and assign to Drivosity all of your right, title,
                and interest in and to any such Submissions, including without limitation, any and all related
                patent, copyright, moral rights, trademark, and other intellectual property rights. Drivosity has no
                obligation to maintain any confidentiality with respect to any such Submissions. Drivosity shall
                be free to use them for any purpose whatsoever without providing you notice or receiving your
                consent, and without restriction or compensation.
            </>
        ),
        location: `/terms-of-use`,
        data: null,
    },
];

export {TermsOfUseData};
